(function () {
  'use strict';
  if (window.__gbCodeDisplay) return;
  window.__gbCodeDisplay = true;

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var state = { cart: null, map: null, drawerKey: null, sig: null };
  var MINUS = '−';

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    if (!m) return null;
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }

  function cleanCode(c) {
    if (!c) return null;
    c = String(c).trim();
    if (!c || c.length > 60) return null;
    return c;
  }

  function loadMap() {
    if (state.map) return state.map;
    var raw = '';
    var el = document.getElementById('GbCodeMap');
    if (el) { try { raw = JSON.parse(el.textContent) || ''; } catch (e) { raw = ''; } }
    var out = [];
    String(raw).split(/\r?\n|,/).forEach(function (line) {
      var m = line.match(/^\s*([^=:]+?)\s*[=:]\s*(\d+(?:\.\d+)?)\s*%?\s*$/);
      if (m) out.push({ prefix: m[1].toUpperCase(), pct: parseFloat(m[2]) });
    });
    out.sort(function (a, b) { return b.prefix.length - a.prefix.length; });
    state.map = out;
    return out;
  }

  function currentCode() {
    var c = cleanCode(readCookie('discount_code'));
    if (c) return c;
    var dc = state.cart && state.cart.discount_codes;
    if (dc && dc.length) return cleanCode(dc[0].code);
    return null;
  }

  function percentFor(code) {
    var up = code.toUpperCase();
    var cart = state.cart;
    if (cart) {
      var apps = (cart.cart_level_discount_applications || []).slice();
      (cart.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (al) {
          if (al.discount_application) apps.push(al.discount_application);
        });
      });
      for (var i = 0; i < apps.length; i++) {
        var a = apps[i];
        if (a && a.type === 'discount_code' && String(a.title || '').toUpperCase() === up) {
          if (a.value_type === 'percentage') return parseFloat(a.value);
          return null;
        }
      }
    }
    var map = loadMap();
    for (var j = 0; j < map.length; j++) {
      if (up.indexOf(map[j].prefix) === 0) return map[j].pct;
    }
    return null;
  }

  function pctLabel(p) {
    var r = Math.round(p * 100) / 100;
    return (r % 1 === 0 ? r.toFixed(0) : String(r)) + '%';
  }

  function formatMoney(cents) {
    var f = (window.theme && window.theme.moneyFormat) || window.mu_money_format || '${{amount}}';
    f = String(f).replace(/<[^>]*>/g, '');
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function d(n, places, thou, dec) {
      var s = (n / 100).toFixed(places).split('.');
      return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (s[1] ? dec + s[1] : '');
    }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      default: v = d(cents, 2, ',', '.');
    }
    return m ? f.replace(m[0], v) : '$' + v;
  }

  function discountCents(price, pct) {
    return Math.floor(price * pct / 100 + 1e-9);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function variantIdFor(line) {
    var root = line.closest('product-info') || line.closest('[data-section-id]') || line.closest('.shopify-section') || document;
    var inp = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (inp && inp.value) return String(inp.value);
    var q = location.search.match(/[?&]variant=(\d+)/);
    if (q) return q[1];
    return line.getAttribute('data-variant-id');
  }

  function pricesFor(line) {
    var out = {};
    (line.getAttribute('data-prices') || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2) out[kv[0]] = parseInt(kv[1], 10);
    });
    return out;
  }

  function renderPdp(code, pct) {
    var lines = document.querySelectorAll('[data-gb-code-line]');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!code) { if (!line.hidden || line.firstChild) { line.hidden = true; line.textContent = ''; line.removeAttribute('data-gb-key'); } continue; }
      var prices = pricesFor(line);
      var vid = variantIdFor(line);
      var price = prices[vid];
      if (price == null) price = prices[line.getAttribute('data-variant-id')];
      var key = code + '|' + pct + '|' + price;
      if (line.getAttribute('data-gb-key') === key && !line.hidden) continue;
      line.textContent = '';
      line.appendChild(document.createTextNode('Code '));
      line.appendChild(el('strong', 'gb-code-line__code', code));
      if (pct != null && price > 0) {
        var after = price - discountCents(price, pct);
        line.appendChild(document.createTextNode(' applied: '));
        line.appendChild(el('strong', 'gb-code-line__price', formatMoney(after)));
        line.appendChild(document.createTextNode(' (' + pctLabel(pct) + ' off)'));
      } else {
        line.appendChild(document.createTextNode(' applied at checkout'));
      }
      line.setAttribute('data-gb-key', key);
      line.hidden = false;
    }
  }

  var narrowMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function isNarrow() { return narrowMq ? narrowMq.matches : window.innerWidth < 750; }

  var annOriginals = [];

  function annTargets() {
    var found = [];
    var nodes = document.querySelectorAll('.announcement__slide p, .announcement__slide .announcement__text > div');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.tagName !== 'P' && n.querySelector('p')) continue;
      var known = null;
      for (var k = 0; k < annOriginals.length; k++) if (annOriginals[k].node === n) known = annOriginals[k];
      if (known) { found.push(known); continue; }
      if (/\bCODE\s*:/i.test(n.textContent || '')) {
        var rec = { node: n, html: n.innerHTML, swapped: false };
        annOriginals.push(rec);
        found.push(rec);
      }
    }
    return found;
  }

  function refreshTickers(targets) {
    var seen = [];
    targets.forEach(function (rec) {
      var t = rec.node.closest && rec.node.closest('ticker-bar');
      if (t && seen.indexOf(t) === -1) seen.push(t);
    });
    seen.forEach(function (t) {
      try { t.dispatchEvent(new CustomEvent('theme:ticker:refresh')); } catch (e) {}
    });
  }

  function renderAnn(code, pct) {
    var targets = annTargets();
    var changed = [];
    targets.forEach(function (rec) {
      var n = rec.node;
      if (!code) {
        if (rec.swapped) { n.innerHTML = rec.html; rec.swapped = false; rec.key = null; changed.push(rec); }
        return;
      }
      var narrow = isNarrow();
      var key = code + '|' + pct + '|' + narrow;
      if (rec.swapped && rec.key === key) return;
      n.textContent = '';
      if (narrow) {
        if (pct != null) {
          n.appendChild(document.createTextNode(pctLabel(pct) + ' off applied '));
          n.appendChild(el('span', 'announcement__divider'));
          n.appendChild(document.createTextNode(' Code ' + code));
        } else {
          n.appendChild(document.createTextNode('Code ' + code + ' applied'));
        }
      } else {
        var first = pct != null ? 'Your ' + pctLabel(pct) + ' off is applied' : 'Your discount is applied';
        n.appendChild(document.createTextNode(first + ' '));
        n.appendChild(el('span', 'announcement__divider'));
        n.appendChild(document.createTextNode(' Code ' + code + ' '));
        n.appendChild(el('span', 'announcement__divider'));
        n.appendChild(document.createTextNode(' Nothing to type'));
      }
      rec.swapped = true;
      rec.key = key;
      changed.push(rec);
    });
    if (changed.length) refreshTickers(changed);
  }

  function drawerRows(cart) {
    var by = {};
    var order = [];
    function add(title, amt) {
      if (!title) return;
      if (!(title in by)) { by[title] = 0; order.push(title); }
      by[title] += amt || 0;
    }
    if (!cart) return [];
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type === 'discount_code') add(a.title, a.total_allocated_amount);
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var da = al.discount_application || {};
        if (da.type === 'discount_code') add(da.title, al.amount);
      });
    });
    return order.map(function (k) { return { code: k, amt: by[k] }; }).filter(function (r) { return r.amt > 0; });
  }

  function tagIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('width', '13');
    svg.setAttribute('height', '13');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z');
    var c = document.createElementNS(ns, 'circle');
    c.setAttribute('cx', '7');
    c.setAttribute('cy', '7');
    c.setAttribute('r', '1.5');
    c.setAttribute('fill', 'currentColor');
    svg.appendChild(p);
    svg.appendChild(c);
    return svg;
  }

  function renderDrawer() {
    var cont = document.getElementById('mu-checkout-container');
    if (!cont || !state.cart) return;
    var rows = drawerRows(state.cart);
    var key = rows.map(function (r) { return r.code + ':' + r.amt; }).join('|');
    var existing = cont.querySelectorAll('[data-gb-discount-row]');
    var anchor = cont.querySelector('[class*="mu:savings"]') || document.getElementById('mu-ocu-container') || null;
    var inPlace = existing.length === rows.length;
    if (inPlace && existing.length) {
      var last = existing[existing.length - 1];
      if (last.parentNode !== cont || (anchor && last.nextElementSibling !== anchor)) inPlace = false;
    }
    if (inPlace && state.drawerKey === key) return;
    for (var i = 0; i < existing.length; i++) existing[i].parentNode.removeChild(existing[i]);
    state.drawerKey = key;
    rows.forEach(function (r) {
      var row = el('div', 'gb-discount-row');
      row.setAttribute('data-gb-discount-row', '');
      var left = el('span', 'gb-discount-row__label');
      left.appendChild(el('span', 'gb-discount-row__code', r.code));
      left.appendChild(tagIcon());
      left.appendChild(el('span', null, 'SAVINGS'));
      row.appendChild(left);
      row.appendChild(el('span', 'gb-discount-row__amt', MINUS + formatMoney(r.amt)));
      if (anchor && anchor.parentNode === cont) cont.insertBefore(row, anchor);
      else cont.insertBefore(row, cont.firstChild);
    });
  }

  var KL_FORMS = ['RApLfN', 'R62Y96'];
  // Popup suppression for code visitors OFF (2026-10-13): hiding after Klaviyo logged the view left
  // an unclosable form that re-fired every page and cost ~25-30 signups/day. Set true to restore.
  var SUPPRESS_KL = false;

  function suppressKlaviyo() {
    if (!SUPPRESS_KL) return;
    if (!document.documentElement.classList.contains('gb-has-code')) return;
    var ours = [];
    KL_FORMS.forEach(function (id) {
      var forms = document.querySelectorAll('[data-testid="klaviyo-form-' + id + '"], .klaviyo-form-' + id);
      for (var i = 0; i < forms.length; i++) {
        var d = forms[i].closest('[role="dialog"]');
        if (d && ours.indexOf(d) === -1) ours.push(d);
      }
    });
    if (!ours.length) return;
    ours.forEach(function (d) {
      if (d.style.getPropertyValue('display') !== 'none') d.style.setProperty('display', 'none', 'important');
    });
    var others = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    for (var j = 0; j < others.length; j++) {
      var o = others[j];
      if (ours.indexOf(o) === -1 && /kl-private-reset/.test(o.className) && getComputedStyle(o).display !== 'none') return;
    }
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }

  function renderAll() {
    var code = currentCode();
    document.documentElement.classList.toggle('gb-has-code', !!code);
    if (code) suppressKlaviyo();
    var pct = code ? percentFor(code) : null;
    renderAnn(code, pct);
    renderPdp(code, pct);
    renderDrawer();
  }

  var inflight = null;
  var again = false;
  function refreshCart() {
    if (!nativeFetch) return;
    if (inflight) { again = true; return; }
    inflight = nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) state.cart = c; })
      .catch(function () {})
      .then(function () {
        inflight = null;
        renderAll();
        if (again) { again = false; refreshCart(); }
      });
  }

  function drawerSig() {
    var cont = document.getElementById('mu-checkout-container');
    if (!cont) return 'none';
    var vals = [];
    var dv = cont.querySelectorAll('[data-value]');
    for (var i = 0; i < dv.length; i++) vals.push(dv[i].getAttribute('data-value'));
    var w = document.getElementById('monster-cart-wrapper');
    var items = w ? w.querySelectorAll('.mu-cart-item').length : 0;
    return vals.join(',') + '#' + items;
  }

  var tick = null;
  function onMutate() {
    if (tick) return;
    tick = setTimeout(function () {
      tick = null;
      var sig = drawerSig();
      if (sig !== state.sig) {
        var first = state.sig === null;
        state.sig = sig;
        if (!first && sig !== 'none') { refreshCart(); return; }
      }
      renderAll();
    }, 120);
  }

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch) {
    var wrapped = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input);
      var p = wrapped.apply(this, arguments);
      if (CART_WRITE.test(url)) {
        p.then(function () { setTimeout(refreshCart, 250); }, function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_WRITE.test(String(url))) {
        this.addEventListener('loadend', function () { setTimeout(refreshCart, 250); });
      }
      return open.apply(this, arguments);
    };
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && t.closest && t.closest('form[action*="/cart/add"]')) setTimeout(renderAll, 0);
  }, true);

  if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    try { window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function () { setTimeout(renderAll, 0); }); } catch (e) {}
  }

  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (d && d.type === 'open' && KL_FORMS.indexOf(d.formId) !== -1) {
      suppressKlaviyo();
      setTimeout(suppressKlaviyo, 50);
      setTimeout(suppressKlaviyo, 400);
    }
  });

  function start() {
    if (narrowMq) {
      var onMq = function () { renderAll(); };
      if (narrowMq.addEventListener) narrowMq.addEventListener('change', onMq);
      else if (narrowMq.addListener) narrowMq.addListener(onMq);
    }
    renderAll();
    refreshCart();
    new MutationObserver(function () { suppressKlaviyo(); }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(onMutate).observe(document.body, {
      childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-value']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
